<template>
    <nav class="navbar navbar-expand-lg navbar-fixed">
        <div class="container-fluid">
            <div class="navbar-wrapper">
                <div class="navbar-minimize" @click="sideBarToggleMini">
                    <button id="minimizeSidebar" class="btn btn-warning btn-fill btn-round btn-icon d-none d-lg-block">
                        <i class="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
                        <i class="fa fa-navicon visible-on-sidebar-mini"></i>
                    </button>
                </div>
            </div>
            <button class="navbar-toggler navbar-toggler-right" type="button" :class="{'toggled': sidebar.mobile}"
                    data-toggle="collapse" aria-controls="navigation-index"
                    aria-expanded="true" aria-label="Toggle navigation"
                    @click="sideBarToggleMobile">
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
            </button>

            <div class="collapse navbar-collapse justify-content-end">
                <ul class="navbar-nav">
                    <li class="nav-item dropdown" :class="{'show': userNavShow}">
                        <a class="nav-link dropdown-toggle" href="#" @click="toggleUserNavigation" v-click-outside="hideUserNavigation">
                            <i class="nc-icon nc-bullet-list-67"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" :class="{'show': userNavShow}">
                            <a href="#" class="dropdown-item" @click="logOut">Выйти</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                userNavShow: false
            }
        },
        computed: {
            ...mapState(['sidebar'])
        },
        methods: {
            logOut() {
                this.$store.dispatch('logOut');
            },
            sideBarToggleMini() {
                this.$store.dispatch('sideBarToggleMini');
            },
            sideBarToggleMobile() {
                this.$store.dispatch('sideBarToggleMobile');
            },
            toggleUserNavigation() {
                this.userNavShow = !this.userNavShow;
            },
            hideUserNavigation() {
                this.userNavShow = false;
            }
        }
    }
</script>
